module.exports = __webpack_public_path__ + "images/subpage-shopping-cart.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/subpage-shopping-cart.png
// module id = 893
// module chunks = 124